import Vue from 'vue'
import Vuex from 'vuex'

import COVER from '@/utils/COVER'
import COVERAPP from '@/utils/COVERAPP'

Vue.use(Vuex)

let aid = '5fc4a2bd352b6e00302a8761';//活动id

export default new Vuex.Store({
	state: {
		aid: aid, //活动id
		isApp: false, //是否在app中
		activityData: '',
		userinfo: {}, //用户信息
		shareData: { //分享信息
			title: '十四五，文化听你说',
			desc: '未来五年，文化、文旅、文博、文学等事业，如何更上新台阶？快来献策四川文化改革发展吧',
			imgUrl: 'https://yunyingcdn.thecover.cn/o_1eqcgasmbt6meofr4t1hno1ocp9.jpg',
			link: window.location.href,
			callback() {
				COVER.track(aid, 'share', '分享');
			}
		},
		toastData: {},
	},
	mutations: {
		// 设置是否在app中
		appFlag(state, flag) {
			state.isApp = flag
		},
		setPageLoading(state, flag) {
			state.pageLoading = flag
		},
		getActivityData(state, data) {
			state.activityData = data
		},
		// 设置用户信息
		getUserinfo(state, data) {
			state.userinfo = data
		},
		// 设置分享数据
		setshareData(state, data) {
			if (!data.callback && typeof data.callback !== 'function') {
				data.callback = (res) => {
					COVER.track(state.aid, 'share', data.link);
				}
			}
			state.shareData = data;
			COVER.share(data);
		},
		// 设置Toast
		setToast(state, data) {
			state.toastData = data;
			setTimeout(() => {
				state.toastData = {};
			}, 1500);
		},
	},
	actions: {
		// 设置是否在app中
		appFlagAsync({ commit, state }, flag) {
			commit('appFlag', flag)
		},
		getActivityDataAsync({ commit, state }, data) {
			commit('getActivityData', data)
		},
		// 获取用户信息
		getUserinfoAsync({ commit, state }) {
			if (COVERAPP.Attribute.isApp()) {
				let _this = this;
				let isLoad_Bridging = setInterval(() => {
					try {
						COVERAPP.Method.GetUser({
							callback(res) {
								clearInterval(isLoad_Bridging);
								let userinfo = JSON.parse(res);
								if (!COVER.isEmpty(userinfo.user_id)) {
									if (COVERAPP.Attribute.isIOS()) {
										if (parseInt(state.versionSize) >= 450) {
											userinfo.nickname = decodeURIComponent(escape(window.atob(userinfo.nickname)));
										}
									}
									sessionStorage.setItem('COVER_USERINFO', JSON.stringify(userinfo))
									commit('getUserinfo', userinfo)
								}
							}
						});
					} catch (e) { }
				}, 300)
			} else {
				COVER.getUser((res) => {
					commit('getUserinfo', JSON.parse(JSON.stringify(res)))
				})
			}
		},
		setUserinfo({ commit, state }, data) {
			commit('getUserinfo', data);
		},
		// 设置分享数据
		setshareDataAsync({ commit, state }, data) {
			commit('setshareData', data)
		},
		setPageLoadingAsync({ commit, state }, flag) {
			commit('setPageLoading', flag)
		},
		Toast({ commit }, data) {
			commit('setToast', data);
		},
	},
	modules: {
	}
})
